import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core'
import { MatTableDataSource } from '@angular/material/table'
import { Portfolio } from 'src/app/features/portfolio/portfolio.model'
import { CHART_COLOR_CODE } from 'src/app/features/shared/constants/chart-color-codes'
import { UnderlyingFund } from 'src/app/models/allocation-response.model'
import { Footnote } from 'src/app/models/footnote.model'
import { FootnoteService } from 'src/app/services/footnotes/footnotes.service'
import { environment } from 'src/environments/environment'

@Component({
  selector: 'app-allocation-to-underlyingfunds',
  templateUrl: './allocation-to-underlyingfunds.component.html',
  styleUrls: ['./allocation-to-underlyingfunds.component.scss'],
})
export class AllocationToUnderlyingfundsComponent {
  @Input() portfolioModel: Portfolio
  @Input() chartData: UnderlyingFund
  @Input() shortName: string
  @ViewChild('theTable') theTable: ElementRef<HTMLTableElement>

  //chart
  chartId = 'assetAllocationPieChart2'
  tableId = 'assetAllocationTable2'
  dataSource: MatTableDataSource<any>
  displayedColumns = [
    'allocationByColor',
    'name',
    'ticker',
    'cusip',
    'sedol',
    'shares',
    'market',
    'notional',
    'value',
  ]
  displayedColumnsEtfs = ['allocationByColor', 'name', 'value']
  chartAndTable = []
  assetAllocationData = []
  allocationUnderlyingFootNote: Footnote
  allocationUnderlyingCusipFootNote: Footnote
  allocationFootNoteDisplay = false
  allocationFootNoteCusip = false
  allocationSecurityIds = ['92203J100', '92203J308', '92203J209']
  allocationSecurityId = ['92203C105', '921939609']
  asOfDate: string
  ticker = ''
  cusip = ''
  sedol = ''
  shares = ''
  marketValue = ''
  notionalValue = ''
  others = ''
  colorIndex = 0
  selectPathData = undefined
  tableContainer: HTMLElement
  showRightButton = true
  innerWidth: number
  constructor(private readonly footnoteService: FootnoteService) {}

  ngOnInit() {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    this.showAllocationUnderlyingFundFootNote()
  }

  getColorCode(index) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    if (index > 15) {
      this.colorIndex = 0
    } else {
      this.colorIndex = index
    }
    return CHART_COLOR_CODE.color[this.colorIndex]
  }
  ngOnChanges() {
    this.getChartData()
  }

  showAllocationUnderlyingFundFootNote() {
    if (this.allocationFootNoteDisplay) {
      this.allocationUnderlyingFootNote = new Footnote(
        /*eslint max-len: ["error", 350]*/
        'The Fund may be invested in a combination of Vanguard Total International Bond Index Fund and Vanguard ' +
          'Total International Bond || Index Fund to achieve its target allocation to non-U.S bonds',
        'portfolio',
        false,
        'footnote_allocation_underlying_fund',
      )
      this.footnoteService.addFootnote(this.allocationUnderlyingFootNote)
    }
    if (this.allocationFootNoteCusip) {
      this.allocationUnderlyingCusipFootNote = new Footnote(
        "Information on this fund can be found on Vanguard's Institutional Investors site.",
        'portfolio',
        false,
        'footnote_allocation_underlying_fund_cusip',
      )
      this.footnoteService.addFootnote(this.allocationUnderlyingCusipFootNote)
    }
  }
  getChartData() {
    if (this.chartData !== null && this.chartData.fundAllocated) {
      this.asOfDate = this.chartData.asOfDate
      this.assetAllocationData = this.chartData.fundAllocated.map(
        // eslint-disable-next-line complexity, max-statements
        (longItem: any, index) => {
          let _secutiryKey = false
          let _securityCusip = false
          if (this.allocationSecurityIds.includes(longItem.securityId)) {
            _secutiryKey = true
            this.allocationFootNoteDisplay = true
          }
          if (this.allocationSecurityId.includes(longItem.securityId)) {
            _securityCusip = true
            this.allocationFootNoteCusip = true
          }
          return {
            id: longItem.name + index,
            name: longItem.name,
            nameFundLink:
              environment.allocationMfsRedirectUrl +
              longItem?.ticker?.toLowerCase(),
            nameLink:
              environment.allocationEtfsRedirectUrl +
              longItem?.ticker?.toLowerCase(),
            // eslint-disable-next-line @typescript-eslint/no-magic-numbers
            disLink:
              (!longItem.securityId && !longItem.cusip) ||
              // eslint-disable-next-line @typescript-eslint/no-magic-numbers
              longItem?.cusip?.length > 9 ||
              // eslint-disable-next-line @typescript-eslint/no-magic-numbers
              longItem?.securityId?.length > 9,
            value: longItem.percent,
            ticker: longItem.ticker,
            cusip: longItem.cusip,
            sedol: longItem.sedol,
            shares: longItem.shareQty,
            marketValue: longItem.marketPrice,
            notionalValue: longItem.notionalValue,
            color: this.getColorCode(index),
            secutiryKey: _secutiryKey,
            securityCusip: _securityCusip,
            securityId: longItem.securityId,
          }
        },
      )
      this.chartAndTable = []
      this.chartAndTable = [...this.assetAllocationData]
      this.dataSource = new MatTableDataSource(this.chartAndTable)
    }
  }
  selectPath(rowId) {
    this.selectPathData = {
      chartId: this.chartId,
      tableId: this.tableId,
      trId: rowId,
    }
  }
}
